const request = {
    invalid_input: 'Eingabe ist ungültig. {{details}}',
    general: 'Es ist ein Fehler bei der Anfrage aufgetreten.',
    range_not_satisfiable: 'Der Bereich ist nicht erfüllbar.',
};
export default Object.freeze(request);
